export enum UserPages {
  PageRoleSelection = 'page.role-selection',
}
